import { render, staticRenderFns } from "./DefaultWorkflowQueue.vue?vue&type=template&id=2d3f939a&scoped=true&"
import script from "./DefaultWorkflowQueue.vue?vue&type=script&lang=ts&"
export * from "./DefaultWorkflowQueue.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultWorkflowQueue.vue?vue&type=style&index=0&id=2d3f939a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f939a",
  null
  
)

export default component.exports